import axios from "services/api";;
import { API3_HOST } from 'helpers/urlHelper';

export const getRTLMissingScansByDate = async (from, to) => {
  return await axios({
    method: 'GET',
    url: `${API3_HOST}/rtl-missing-scanned/frames?from=${from}&to=${to}`
  });
};
